import React, { useState, useEffect } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import ca from 'date-fns/esm/locale/ca/index.js';
import {
  Badge
  // Button
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { IoIosArrowDown } from 'react-icons/io';
// import { IoIosArrowUp } from 'react-icons/io';
import { PickersDay, TimePicker } from '@mui/x-date-pickers';
import { CURRENT_DATE, SELECTED_TIME } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
// import { previousDay } from 'date-fns';

const events = [new Date('2024-01-01'), new Date('2024-01-02')];

function ServerDay(props) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;
  // console.log(props);
  const isSelected = !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.getDate()) >= 0;

  return (
    <Badge
      key={props.day.toString()}
      overlap="circular"
      sx={isSelected ? { margin: '2px', borderRadius: '50%' } : undefined}
      badgeContent={isSelected ? '' : undefined}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      variant={'dot'}
      color={isSelected ? 'primary' : undefined}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
    </Badge>
  );
}

function DatePickerStore() {
  const [calender, 
    // setCalender
  ] = useState(new Date("2024-06-20"));
  // const [openTimeDropdown, setOpenTimeDropdown] = useState(false);
  // const [selectedTime, setSelectedTime] = useState(calender);
  // const [selectedDate, setSelectedDate] = useState(formatDate(initialDate));
  const [highlightedDays, setHighlightedDays] = useState([]);
  const [
    timeData
    // setTimeData
  ] = useState('00:00');
  const dispatch = useDispatch();
  const selectedTime = useSelector((state) => state.customization.selectedTime);
  useEffect(() => {
    setHighlightedDays([]);
    const daysToHighlight = events.map((event) => {
      const today = new Date();
      if (event.getMonth() === today.getMonth()) {
        return event.getDate();
      }
      return;
    });
    setHighlightedDays(daysToHighlight);
    // eslint-disable-next-line
  }, [events]);

  const handleMonthChange = (date) => {
    // console.log(date.getMonth());
    const daysToHighlight = events.map((event) => {
      // console.log(event.getMonth());
      if (event.getMonth() === date.getMonth()) {
        return event.getDate();
      }
      return;
    });

    setHighlightedDays([]);
    setHighlightedDays(daysToHighlight);
  };

  const handlechange = () => {
    // setCalender(date);
    // const formattedDate = formatDate(date);
    // console.log(Selected Date: ${formattedDate});

    // setOpenTimeDropdown(true);
    // setSelectedDate(formattedDate);
  };

  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  function formatDate(date, time) {
    //2024-01-01T00:00:00.000Z
    // console.log([date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join('-')+ "T" + time +":00.000Z");
    // console.log(time);
    return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join('-') + 'T' + time + ':00.000Z';
  }

  // const shouldDisableDate = (day) => {
  //   // Enable January 1, January 2, and February 11, disable all other dates
  //   const month = day.getMonth();
  //   const date = day.getDate();
  //   return !(month === 0 && (date === 1 || date === 2));
  // };

  // const onClickTime = (i) => {
  //   // console.log(`Selected Date: ${calender}, Selected Time: ${i}`);
  //   setOpenTimeDropdown(false);
  //   setSelectedTime(i.time);
  //   setTimeData(i.value);
  // };

  useEffect(() => {
    // SetSelectedDate(formatDate(calender, timeData));
    dispatch({ type: CURRENT_DATE, currentDate: formatDate(calender, timeData) });
    // eslint-disable-next-line
  }, [calender, timeData]);

  return (
    <div className="flex items-center justify-end gap-2 w-[400px]">
      {/* <div className="flex justify-center mt-2 w-full">
        <Button
          className="w-full bg-white text-black font-thin border-[#C4C4C4] "
          variant="outlined"
          color="primary"
          onClick={() => setOpenTimeDropdown((prev) => !prev)}
          sx={{ textTransform: 'none' }}
        >
          <p className="flex justify-between gap-2 w-full items-center">
            {selectedTime}
            {openTimeDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </p>
        </Button>
      </div> */}
      {/* {openTimeDropdown && (
        <div className="p-3 w-[255px] h-[200px] overflow-y-scroll z-50 scrollbar absolute right-10 bg-white rounded-xl shadow-full">
          {timeIntervals.map((i, index) => (
            <div
              key={index}
              className={`text-center p-1 hover:bg-green-100 duration-200 rounded-lg cursor-pointer ${
                i.time === selectedTime ? 'bg-green-100' : ''
              } `}
              onClick={() => onClickTime(i)}
            >
              {i.time}
            </div>
          ))}
        </div>
      )} */}
      <div className="flex gap-2 w-80">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            defaultValue={dayjs(calender).startOf('day').hour(13).minute(15)}
            sx={{
              bgcolor: 'white',
              '& .MuiInputBase-root': {
                height: '40px' // Adjust the height as needed
              }
            }}
            disabled
            onChange={(date) =>
              dispatch({
                type: SELECTED_TIME,
                selectedTime: {
                  ...selectedTime,
                  start_time: new Date(date).getTime()
                  // start_time: new Date(date).getTime() > new Date().getTime() ? new Date().getTime() : new Date(date).getTime()
                }
              })
            }
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            defaultValue={dayjs(calender).startOf('day').hour(15).minute(40)}
            sx={{
              bgcolor: 'white',
              '& .MuiInputBase-root': {
                height: '40px' // Adjust the height as needed
              }
            }}
            disabled
            onChange={(date) =>
              dispatch({
                type: SELECTED_TIME,
                selectedTime: {
                  ...selectedTime,
                  end_time: new Date(date).getTime()
                  // end_time: new Date(date).getTime() > new Date().getTime() ? new Date().getTime() : new Date(date).getTime()
                }
              })
            }
          />
        </LocalizationProvider>
      </div>
      <div className="w-52">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            className="cursor-pointer"
            sx={{
              bgcolor: 'white',
              paddingTop: 0,
              '& .MuiInputBase-root': {
                height: '40px', // Adjust the height as needed
                width: '100%'
              }
            }}
            slots={{
              day: ServerDay
            }}
            slotProps={{
              textField: {
                fullWidth: true,
                bgcolor: 'white'
                // readOnly: true,
                // onClick: () => setOpen(true),
              },
              day: {
                highlightedDays
              }
            }}
            disabled
            format="dd/MM/yyyy"
            id="date-picker-inline"
            value={calender}
            onChange={handlechange}
            onMonthChange={handleMonthChange}
            // shouldDisableDate={shouldDisableDate}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
}

export default DatePickerStore;
